define(['backbone', 'models/LightWallet'], function(Backbone, LightWallet) {
  return Backbone.Collection.extend({
    model: LightWallet,
  });
});
